module.exports = __webpack_public_path__ + "img/login-hero-mobile-1.cf8eef1c.jpg";